import PropTypes from 'prop-types';
import * as React from 'react';

import '../styles/main.scss';

const Layout = ({ children }) => {
  return (
    <>
      <>{children}</>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
